import * as ko from 'knockout';

import { I18nText } from '../i18n_text';
import { SeasonData } from '../api/seasons';
import { canEditSeason } from '../permissions';
import { SlugGenerator } from '../ko_bindings/slug_validation';

export class Season {
  private slugGenerator: SlugGenerator;

  id = ko.observable<string>(null);
  nameJson = ko.observable<I18nText>().extend({
    i18nTextRequired: true,
    serverError: true,
  });
  code = ko.observable('').extend({
    required: true,
    serverError: true,
  });

  canEdit = canEditSeason();

  constructor(data?: SeasonData) {
    if (data) {
      this.id(data.id);
      this.nameJson(data.name_json);
      this.code(data.code);
    }

    // Seasons saved before the code became mandatory have none, so they are also offered a
    // suggestion; otherwise they could not be saved at all, not even to change the name.
    this.slugGenerator = new SlugGenerator(this.nameJson, null, this.code, {
      canEdit: !this.id() || !this.code(),
      fillIfEmpty: true,
    });
  }

  toData(): SeasonData {
    return {
      id: this.id(),
      name_json: this.nameJson(),
      code: this.code(),
    };
  }

  dispose() {
    this.slugGenerator.dispose();
  }
}
